import { APPSEC_FIELDS, CLOUD_APPSEC_FIELDS } from "./analysis/designSolutionUtils";

/** Production Analysis Design card field lists, reused by RFP Discovery Scope Analysis. */
export const SCOPE_CARD_FIELDS = {
  integrated_waf: new Set(APPSEC_FIELDS),
  cloud_waf: new Set(CLOUD_APPSEC_FIELDS),
};

export function fieldIsOnScopeCard(card, fieldId) {
  const allowed = SCOPE_CARD_FIELDS[card?.technology_id];
  if (!allowed) return true;
  if (String(fieldId || "").startsWith("design.global_management.")) return true;
  return allowed.has(fieldId);
}
